import { Box, useTheme } from "@mui/material";

const PaperContainer = ({ children }) => {
  const theme = useTheme();
  return (
    <Box
      style={{
        border: "1px solid " + theme.palette.grey[200],
        borderRadius: "10px",
        boxShadow: theme.customShadows.z16,
        overflow: "hidden",
        display: "flex",
        flexGrow: 1,
        height: "100%",
        width: "100%",
      }}
    >
      {children}
    </Box>
  );
};

export default PaperContainer;
